import React, { useState, useEffect } from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useForm, useWatch } from 'react-hook-form';
import FormTextField from '../../common/Forms/FormTextField';
import InputDropdown from '../../common/Forms/InputDropdown';
import FormInputMultiCheckbox from '../../common/Forms/FormCheckbox';
import {
  EPISODE_PROFA2_URL,
  formDateFormat,
  yesNoDropdown,
  PROFA2_REFERRAL_UPDATE_DATA,
  maxLength
} from '../../../constants';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Auth } from 'aws-amplify';
import moment from 'moment';
import {
  getProfA2Form,
  setCommentOnRecommendations,
  setDateSigned,
  setDayTreatment,
  setDrug1AgeFirstUsed,
  setDrug1FrequencyId,
  setDrug1InTakeId,
  setDrug1UsedId,
  setDrug2AgeFirstUsed,
  setDrug2FrequencyId,
  setDrug2InTakeId,
  setDrug2UsedId,
  setDrug3AgeFirstUsed,
  setDrug3FrequencyId,
  setDrug3InTakeId,
  setDrug3UsedId,
  setDrug4AgeFirstUsed,
  setDrug4FrequencyId,
  setDrug4InTakeId,
  setDrug4UsedId,
  setFOTEP,
  setIsProfA2DataLoaded,
  setLengthofTimeSinceClientLastUsed,
  setNotReferredInappropriate,
  setNotReferredRefusingTreatment,
  setOutPatient,
  setProgram1Completed,
  setProgram1Modality,
  setProgram1Name,
  setProgram1TreatmentLength,
  setProgram1Year,
  setProgram2Completed,
  setProgram2Modality,
  setProgram2Name,
  setProgram2TreatmentLength,
  setProgram2Year,
  setProgram3Completed,
  setProgram3Modality,
  setProgram3Name,
  setProgram3TreatmentLength,
  setProgram3Year,
  setProgramTransitionalStaffId,
  setRecommendResidentialWithChild,
  setRecommendSoberLivingWithChild,
  setRecommendSoberLivingWithIntensiveOdf,
  setReferredForTreatment,
  setResidential,
  setSoberLiving,
  setTimeSpentinInstitutions,
  setTreatmentAccomplishments,
} from '../../../redux/episode/profA2Tab/profA2FormSlice';
import { setStopApi } from '../../../services/StopApi/StopApi';
import FormSuccess from '../../common/Forms/FormSuccess';
import ProgressBar from '../../common/ProgressBar/ProgressBar';
import CancelPopUp from '../../common/CancelPopUp/CancelPopUp';
import { setRefreshEpisodeParticipant } from '../../../redux/episode/episodeParticipant/episodeParticipantSlice';
import { getSaveCancel } from '../../common/commonUtils/commonUtils';
import { PrintViewGrid } from './ProfA1PdfFormCommonUtils';
import ProfA1PdfForm from './ProfA1PdfForm';

const schema = yup.object().shape({
  treatmentAccomplishments: yup.string().nullable().max(900, `${maxLength} 900`),
  commentOnRecommendations: yup.string().nullable().max(800, `${maxLength} 800`),
});

const ProfA2 = (props) => {
  const dispatch = useDispatch();
  const [formLoading, setFormLoading] = useState(true);
  const [formSuccess, setFormSuccess] = useState(false);
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [user, setUser] = useState(null);
  const [openProfilePDF, setOpenProfilePDF] = useState(false);

  const profA2ReferenceInfo = useSelector(
    (state) => state?.profA2ReferenceData
  );
  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );
  const profA2Form = useSelector((state) => state?.profA2Form);

  const searchItem = (searchKey, searchList, returnValueKey) => {
    const searchItem = searchList.find((item) => item.id === searchKey);
    return searchItem[returnValueKey];
  };
  const getPhoneNumber = (Id) => {
    return searchItem(
      Id,
      profA2ReferenceInfo?.programTransitionalStaff,
      'phone'
    );
  };
  const getFaxNumber = (Id) => {
    return searchItem(Id, profA2ReferenceInfo?.programTransitionalStaff, 'fax');
  };

  const defaultValue = {
    drug1UsedId: profA2Form?.drug1UsedId ? profA2Form?.drug1UsedId : '',
    drug2UsedId: profA2Form?.drug2UsedId ? profA2Form?.drug2UsedId : '',
    drug3UsedId: profA2Form?.drug3UsedId ? profA2Form?.drug3UsedId : '',
    drug4UsedId: profA2Form?.drug4UsedId ? profA2Form?.drug4UsedId : '',
    drug1InTakeId: profA2Form?.drug1InTakeId ? profA2Form?.drug1InTakeId : '',
    drug2InTakeId: profA2Form?.drug2InTakeId ? profA2Form?.drug2InTakeId : '',
    drug3InTakeId: profA2Form?.drug3InTakeId ? profA2Form?.drug3InTakeId : '',
    drug4InTakeId: profA2Form?.drug4InTakeId ? profA2Form?.drug4InTakeId : '',
    drug1FrequencyId: profA2Form?.drug1FrequencyId
      ? profA2Form?.drug1FrequencyId
      : '',
    drug2FrequencyId: profA2Form?.drug2FrequencyId
      ? profA2Form?.drug2FrequencyId
      : '',
    drug3FrequencyId: profA2Form?.drug3FrequencyId
      ? profA2Form?.drug3FrequencyId
      : '',
    drug4FrequencyId: profA2Form?.drug4FrequencyId
      ? profA2Form?.drug4FrequencyId
      : '',
    drug1AgeFirstUsed: profA2Form?.drug1AgeFirstUsed,
    drug2AgeFirstUsed: profA2Form?.drug2AgeFirstUsed,
    drug3AgeFirstUsed: profA2Form?.drug3AgeFirstUsed,
    drug4AgeFirstUsed: profA2Form?.drug4AgeFirstUsed,
    LengthofTimeSinceClientLastUsed:
      profA2Form?.LengthofTimeSinceClientLastUsed,
    TimeSpentinInstitutions: profA2Form?.TimeSpentinInstitutions,
    program1Name: profA2Form?.program1Name,
    program2Name: profA2Form?.program2Name,
    program3Name: profA2Form?.program3Name,
    program1Modality:
      profA2Form?.program1Modality === null ? '' : profA2Form?.program1Modality,
    program2Modality:
      profA2Form?.program2Modality === null ? '' : profA2Form?.program2Modality,
    program3Modality:
      profA2Form?.program3Modality === null ? '' : profA2Form?.program3Modality,
    program1Year: profA2Form?.program1Year,
    program2Year: profA2Form?.program2Year,
    program3Year: profA2Form?.program3Year,
    program1Completed:
      profA2Form?.program1Completed === null
        ? ''
        : profA2Form?.program1Completed,
    program2Completed:
      profA2Form?.program2Completed === null
        ? ''
        : profA2Form?.program2Completed,
    program3Completed:
      profA2Form?.program3Completed === null
        ? ''
        : profA2Form?.program3Completed,
    program1TreatmentLength: profA2Form?.program1TreatmentLength,
    program2TreatmentLength: profA2Form?.program2TreatmentLength,
    program3TreatmentLength: profA2Form?.program3TreatmentLength,
    treatmentAccomplishments: profA2Form?.treatmentAccomplishments,
    commentOnRecommendations: profA2Form?.commentOnRecommendations,
    programTransitionalStaffId: profA2Form?.programTransitionalStaffId,
    referredForTreatment: profA2Form?.referredForTreatment,
    notReferredInappropriate: profA2Form?.notReferredInappropriate,
    notReferredRefusingTreatment: profA2Form?.notReferredRefusingTreatment,
    residential: profA2Form?.residential,
    soberLiving: profA2Form?.soberLiving,
    outPatient: profA2Form?.outPatient,
    dayTreatment: profA2Form?.dayTreatment,
    recommendResidentialWithChild: profA2Form?.recommendResidentialWithChild,
    recommendSoberLivingWithChild: profA2Form?.recommendSoberLivingWithChild,
    recommendSoberLivingWithIntensiveOdf:
      profA2Form?.recommendSoberLivingWithIntensiveOdf,
    FOTEP: profA2Form?.FOTEP,
    dateSigned: moment(profA2Form?.dateSigned).format(formDateFormat),
    faxNumber: profA2Form?.programTransitionalStaffId
      ? getPhoneNumber(profA2Form?.programTransitionalStaffId)
      : '',
    telephoneNumber: profA2Form?.programTransitionalStaffId
      ? getPhoneNumber(profA2Form?.programTransitionalStaffId)
      : '',
  };
  
  // const { control, formState, handleSubmit, reset, register } = useForm({
  //   mode: 'onChange',
  //   defaultValues: defaultValue,
  //   resolver: yupResolver(schema),
  // });

  const useFunction = useForm({ defaultValues: defaultValue, resolver: yupResolver(schema) });
  const { handleSubmit, reset, control, formState, setValue, watch, register } = useFunction;
  const { errors } = formState;  

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  // const programTransitionalStaff = useWatch({
  //   control,
  //   name: 'programTransitionalStaff',
  // });

  // const programTransitionalStaffIds =
  //   profA2ReferenceInfo?.programTransitionalStaff.filter((item) =>
  //     item.key === programTransitionalStaff ? item.id : ''
  //   );
  // const programTransitionalStaffvalues = {
  //   id: programTransitionalStaffIds ? programTransitionalStaffIds[0]?.id : '',
  //   key: programTransitionalStaffIds ? programTransitionalStaffIds[0]?.key : '',
  // };

  // useEffect(() => {
  //   dispatch(setProgramTransitionalStaff(programTransitionalStaffvalues));
  // }, [programTransitionalStaff]);

  const fetchData = async () => {
    let profA2TabUrl = `${EPISODE_PROFA2_URL}/${episodeId}/ProfA2`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    //if (profA2Form?.isProfA2DataLoaded === false) {
      dispatch(getProfA2Form({ profA2TabUrl, authorization }));
      setTimeout(() => {
        dispatch(setIsProfA2DataLoaded(true));
      }, 1000);
    //}
    setTimeout(() => {
      setFormLoading(false);
    }, 500);
  };

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.drug1UsedId,
    defaultValue.drug2UsedId,
    defaultValue.drug3UsedId,
    defaultValue.drug4UsedId,
    defaultValue.drug1InTakeId,
    defaultValue.drug2InTakeId,
    defaultValue.drug3InTakeId,
    defaultValue.drug4InTakeId,
    defaultValue.drug1FrequencyId,
    defaultValue.drug2FrequencyId,
    defaultValue.drug3FrequencyId,
    defaultValue.drug4FrequencyId,
    defaultValue.drug1AgeFirstUsed,
    defaultValue.drug2AgeFirstUsed,
    defaultValue.drug3AgeFirstUsed,
    defaultValue.drug4AgeFirstUsed,
    defaultValue.LengthofTimeSinceClientLastUsed,
    defaultValue.TimeSpentinInstitutions,
    defaultValue.program1Name,
    defaultValue.program2Name,
    defaultValue.program3Name,
    defaultValue.program1Modality,
    defaultValue.program2Modality,
    defaultValue.program3Modality,
    defaultValue.program1Year,
    defaultValue.program2Year,
    defaultValue.program3Year,
    defaultValue.program1Completed,
    defaultValue.program2Completed,
    defaultValue.program3Completed,
    defaultValue.program1TreatmentLength,
    defaultValue.program2TreatmentLength,
    defaultValue.program3TreatmentLength,
    defaultValue.treatmentAccomplishments,
    defaultValue.referredForTreatment,
    defaultValue.notReferredInappropriate,
    defaultValue.notReferredRefusingTreatment,
    defaultValue.residential,
    defaultValue.soberLiving,
    defaultValue.outPatient,
    defaultValue.dayTreatment,
    defaultValue.recommendResidentialWithChild,
    defaultValue.recommendSoberLivingWithChild,
    defaultValue.recommendSoberLivingWithIntensiveOdf,
    defaultValue.FOTEP,
    defaultValue.commentOnRecommendations,
    defaultValue.programTransitionalStaffId,
    defaultValue.telephoneNumber,
    defaultValue.faxNumber,
    defaultValue.dateSigned,
  ]);

  const onSubmit = () => {
    const url = PROFA2_REFERRAL_UPDATE_DATA;
    const payload = {
      episodeID: episodeId,
      drug1AgeFirstUsed: profA2Form?.drug1AgeFirstUsed || null,
      drug2AgeFirstUsed: profA2Form?.drug2AgeFirstUsed || null,
      drug3AgeFirstUsed: profA2Form?.drug3AgeFirstUsed || null,
      drug4AgeFirstUsed: profA2Form?.drug4AgeFirstUsed || null,
      LengthofTimeSinceClientLastUsed:
        profA2Form?.LengthofTimeSinceClientLastUsed,
      TimeSpentinInstitutions: profA2Form?.TimeSpentinInstitutions,
      LongestLengthofNonUse: profA2Form?.LongestLengthofNonUse
        ? profA2Form?.LongestLengthofNonUse
        : null,
      TotalLengthofUse: profA2Form?.TotalLengthofUse
        ? profA2Form?.TotalLengthofUse
        : null,
      program1Name: profA2Form?.program1Name,
      program2Name: profA2Form?.program2Name,
      program3Name: profA2Form?.program3Name,
      program1Modality:
        profA2Form?.program1Modality === ''
          ? null
          : profA2Form?.program1Modality,
      program2Modality:
        profA2Form?.program2Modality === ''
          ? null
          : profA2Form?.program2Modality,
      program3Modality:
        profA2Form?.program3Modality === ''
          ? null
          : profA2Form?.program3Modality,
      program1Year: profA2Form?.program1Year,
      program2Year: profA2Form?.program2Year,
      program3Year: profA2Form?.program3Year,
      program1Completed:
        profA2Form?.program1Completed === ''
          ? null
          : profA2Form?.program1Completed,
      program2Completed:
        profA2Form?.program2Completed === ''
          ? null
          : profA2Form?.program2Completed,
      program3Completed:
        profA2Form?.program3Completed === ''
          ? null
          : profA2Form?.program3Completed,
      program1TreatmentLength: profA2Form?.program1TreatmentLength,
      program2TreatmentLength: profA2Form?.program2TreatmentLength,
      program3TreatmentLength: profA2Form?.program3TreatmentLength,
      treatmentAccomplishments: profA2Form?.treatmentAccomplishments,
      referredForTreatment: profA2Form?.referredForTreatment,
      notReferredInappropriate: profA2Form?.notReferredInappropriate,
      notReferredRefusingTreatment: profA2Form?.notReferredRefusingTreatment,
      residential: profA2Form?.residential,
      soberLiving: profA2Form?.soberLiving,
      outPatient: profA2Form?.outPatient,
      dayTreatment: profA2Form?.dayTreatment,
      recommendResidentialWithChild: profA2Form?.recommendResidentialWithChild,
      recommendSoberLivingWithChild: profA2Form?.recommendSoberLivingWithChild,
      recommendSoberLivingWithIntensiveOdf:
        profA2Form?.recommendSoberLivingWithIntensiveOdf,
      FOTEP: profA2Form?.FOTEP,
      commentOnRecommendations: profA2Form?.commentOnRecommendations,
      dateSigned: profA2Form?.dateSigned,
      programTransitionalStaff: profA2Form?.programTransitionalStaffId
        ? profA2Form?.programTransitionalStaffId
        : null,
      drug1Used: profA2Form?.drug1UsedId ? profA2Form?.drug1UsedId : null,
      drug1InTake: profA2Form?.drug1InTakeId ? profA2Form?.drug1InTakeId : null,
      drug1Frequency: profA2Form?.drug1FrequencyId
        ? profA2Form?.drug1FrequencyId
        : null,
      drug2Used: profA2Form?.drug2UsedId ? profA2Form?.drug2UsedId : null,
      drug2InTake: profA2Form?.drug2InTakeId ? profA2Form?.drug2InTakeId : null,
      drug2Frequency: profA2Form?.drug2FrequencyId
        ? profA2Form?.drug2FrequencyId
        : null,
      drug3Used: profA2Form?.drug3UsedId ? profA2Form?.drug3UsedId : null,
      drug3InTake: profA2Form?.drug3InTakeId ? profA2Form?.drug3InTakeId : null,
      drug3Frequency: profA2Form?.drug3FrequencyId
        ? profA2Form?.drug3FrequencyId
        : null,
      drug4Used: profA2Form?.drug4UsedId ? profA2Form?.drug4UsedId : null,
      drug4InTake: profA2Form?.drug4InTakeId ? profA2Form?.drug4InTakeId : null,
      drug4Frequency: profA2Form?.drug4FrequencyId
        ? profA2Form?.drug4FrequencyId
        : null,
    };
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    setStopApi({ url, payload, authorization }).then((response) => {
      if (response.succeeded === true) {
        fetchData();
        setFormSuccess(true);
        dispatch(setRefreshEpisodeParticipant(true));
        setTimeout(() => {
          dispatch(setRefreshEpisodeParticipant(false));
        }, 1000);
      }
    }).catch((e) => alert(e));
  };

  const onError = () => {
    alert('Unable to Save. Please check for field validation errors.')
  }

  const handleCancelPopUp = () => {
    setCancelPopUp(true);
  };

  const handleOpenA1Pdf = () => {
    onSubmit();
    setOpenProfilePDF(true);
  };

  if (formLoading) {
    return <ProgressBar />;
  }
  return (
    <>
      <PrintViewGrid handleOpenPdf={handleOpenA1Pdf} />
      <Grid container style={{ marginTop: '10px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Typography style={{ color: '#b9b2b2' }}>
              Drug Used (1=Primary)
            </Typography>
            <Box>
              <InputDropdown
                name="drug1UsedId"
                control={control}
                options={profA2ReferenceInfo?.drugs}
                defaultId={defaultValue?.drug1UsedId}
                register={register('drug1UsedId', {
                  onBlur: (e) => dispatch(setDrug1UsedId(e.target.value)),
                })}
              />
              <InputDropdown
                name="drug2UsedId"
                control={control}
                options={profA2ReferenceInfo?.drugs}
                defaultId={defaultValue?.drug2UsedId}
                register={register('drug2UsedId', {
                  onBlur: (e) => dispatch(setDrug2UsedId(e.target.value)),
                })}
              />
              <InputDropdown
                name="drug3UsedId"
                control={control}
                options={profA2ReferenceInfo?.drugs}
                defaultId={defaultValue?.drug3UsedId}
                register={register('drug3UsedId', {
                  onBlur: (e) => dispatch(setDrug3UsedId(e.target.value)),
                })}
              />
              <InputDropdown
                name="drug4UsedId"
                control={control}
                options={profA2ReferenceInfo?.drugs}
                defaultId={defaultValue?.drug4UsedId}
                register={register('drug4UsedId', {
                  onBlur: (e) => dispatch(setDrug4UsedId(e.target.value)),
                })}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography style={{ color: '#b9b2b2' }}>
              How Used (inject, Smoke Snort, etc.):
            </Typography>
            <Box>
              <InputDropdown
                name="drug1InTakeId"
                control={control}
                options={profA2ReferenceInfo?.drugIntakes}
                defaultId={defaultValue?.drug1InTakeId}
                register={register('drug1InTakeId', {
                  onBlur: (e) => dispatch(setDrug1InTakeId(e.target.value)),
                })}
              />
              <InputDropdown
                name="drug2InTakeId"
                control={control}
                options={profA2ReferenceInfo?.drugIntakes}
                defaultId={defaultValue?.drug2InTakeId}
                register={register('drug2InTakeId', {
                  onBlur: (e) => dispatch(setDrug2InTakeId(e.target.value)),
                })}
              />
              <InputDropdown
                name="drug3InTakeId"
                control={control}
                options={profA2ReferenceInfo?.drugIntakes}
                defaultId={defaultValue?.drug3InTakeId}
                register={register('drug3InTakeId', {
                  onBlur: (e) => dispatch(setDrug3InTakeId(e.target.value)),
                })}
              />
              <InputDropdown
                name="drug4InTakeId"
                control={control}
                options={profA2ReferenceInfo?.drugIntakes}
                defaultId={defaultValue?.drug4InTakeId}
                register={register('drug4InTakeId', {
                  onBlur: (e) => dispatch(setDrug4InTakeId(e.target.value)),
                })}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography style={{ color: '#b9b2b2' }}>
              Frequency Of Use
            </Typography>
            <Box>
              <InputDropdown
                name="drug1FrequencyId"
                control={control}
                options={profA2ReferenceInfo?.drugFrequencies}
                defaultId={defaultValue?.drug1FrequencyId}
                register={register('drug1FrequencyId', {
                  onBlur: (e) =>
                    dispatch(setDrug1FrequencyId(e.target.value)),
                })}
              />
              <InputDropdown
                name="drug2FrequencyId"
                control={control}
                options={profA2ReferenceInfo?.drugFrequencies}
                defaultId={defaultValue?.drug2FrequencyId}
                register={register('drug2FrequencyId', {
                  onBlur: (e) =>
                    dispatch(setDrug2FrequencyId(e.target.value)),
                })}
              />
              <InputDropdown
                name="drug3FrequencyId"
                control={control}
                options={profA2ReferenceInfo?.drugFrequencies}
                defaultId={defaultValue?.drug3FrequencyId}
                register={register('drug3FrequencyId', {
                  onBlur: (e) =>
                    dispatch(setDrug3FrequencyId(e.target.value)),
                })}
              />
              <InputDropdown
                name="drug4FrequencyId"
                control={control}
                options={profA2ReferenceInfo?.drugFrequencies}
                defaultId={defaultValue?.drug4FrequencyId}
                register={register('drug4FrequencyId', {
                  onBlur: (e) =>
                    dispatch(setDrug4FrequencyId(e.target.value)),
                })}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography style={{ color: '#b9b2b2' }}>Age First Used</Typography>
            <Box>
              <FormTextField
                name="drug1AgeFirstUsed"
                control={control}
                type="text"
                register={register('drug1AgeFirstUsed', {
                  onBlur: (e) =>
                    dispatch(setDrug1AgeFirstUsed(e.target.value)),
                })}
              />
              <FormTextField
                name="drug2AgeFirstUsed"
                control={control}
                type="text"
                register={register('drug2AgeFirstUsed', {
                  onBlur: (e) =>
                    dispatch(setDrug2AgeFirstUsed(e.target.value)),
                })}
              />
              <FormTextField
                name="drug3AgeFirstUsed"
                control={control}
                type="text"
                register={register('drug3AgeFirstUsed', {
                  onBlur: (e) =>
                    dispatch(setDrug3AgeFirstUsed(e.target.value)),
                })}
              />
              <FormTextField
                name="drug4AgeFirstUsed"
                control={control}
                type="text"
                register={register('drug4AgeFirstUsed', {
                  onBlur: (e) =>
                    dispatch(setDrug4AgeFirstUsed(e.target.value)),
                })}
              />
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} style={{ display: 'flex' }}>
            <FormTextField
              name="LengthofTimeSinceClientLastUsed"
              control={control}
              type="text"
              label="Length of time since client last used"
              register={register('LengthofTimeSinceClientLastUsed', {
                onBlur: (e) =>
                  dispatch(setLengthofTimeSinceClientLastUsed(e.target.value)),
              })}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ display: 'flex' }}>
            <FormTextField
              name="TimeSpentinInstitutions"
              control={control}
              type="text"
              label="Time Spent On Institution"
              register={register('TimeSpentinInstitutions', {
                onBlur: (e) =>
                  dispatch(setTimeSpentinInstitutions(e.target.value)),
              })}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={2.4}>
            <Typography style={{ color: '#b9b2b2' }}>Program Name</Typography>
            <Box>
              <FormTextField
                name="program1Name"
                control={control}
                type="text"
                register={register('program1Name', {
                  onBlur: (e) => dispatch(setProgram1Name(e.target.value)),
                })}
              />
              <FormTextField
                name="program2Name"
                control={control}
                type="text"
                register={register('program2Name', {
                  onBlur: (e) => dispatch(setProgram2Name(e.target.value)),
                })}
              />
              <FormTextField
                name="program3Name"
                control={control}
                type="text"
                register={register('program3Name', {
                  onBlur: (e) => dispatch(setProgram3Name(e.target.value)),
                })}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={2.4}>
            <Typography style={{ color: '#b9b2b2' }}>Modality</Typography>
            <Box>
              <InputDropdown
                name="program1Modality"
                control={control}
                options={profA2ReferenceInfo?.programModalities}
                defaultId={defaultValue?.program1Modality}
                register={register('program1Modality', {
                  onBlur: (e) =>
                    dispatch(setProgram1Modality(e.target.value)),
                })}
              />
              <InputDropdown
                name="program2Modality"
                control={control}
                options={profA2ReferenceInfo?.programModalities}
                defaultId={defaultValue?.program2Modality}
                register={register('program2Modality', {
                  onBlur: (e) =>
                    dispatch(setProgram2Modality(e.target.value)),
                })}
              />
              <InputDropdown
                name="program3Modality"
                control={control}
                options={profA2ReferenceInfo?.programModalities}
                defaultId={defaultValue?.program3Modality}
                register={register('program3Modality', {
                  onBlur: (e) =>
                    dispatch(setProgram3Modality(e.target.value)),
                })}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={2.4}>
            <Typography style={{ color: '#b9b2b2' }}>Year Entered</Typography>
            <Box>
              <FormTextField
                name="program1Year"
                control={control}
                type="text"
                register={register('program1Year', {
                  onBlur: (e) => dispatch(setProgram1Year(e.target.value)),
                })}
              />
              <FormTextField
                name="program2Year"
                control={control}
                type="text"
                register={register('program2Year', {
                  onBlur: (e) => dispatch(setProgram2Year(e.target.value)),
                })}
              />
              <FormTextField
                name="program3Year"
                control={control}
                type="text"
                register={register('program3Year', {
                  onBlur: (e) => dispatch(setProgram3Year(e.target.value)),
                })}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={2.4}>
            <Typography style={{ color: '#b9b2b2' }}>Completed?</Typography>
            <Box>
              <InputDropdown
                name="program1Completed"
                control={control}
                options={yesNoDropdown}
                defaultId={defaultValue?.program1Completed}
                register={register('program1Completed', {
                  onBlur: (e) =>
                    dispatch(setProgram1Completed(e.target.value)),
                })}
              />
              <InputDropdown
                name="program2Completed"
                control={control}
                options={yesNoDropdown}
                defaultId={defaultValue?.program2Completed}
                register={register('program2Completed', {
                  onBlur: (e) =>
                    dispatch(setProgram2Completed(e.target.value)),
                })}
              />
              <InputDropdown
                name="program3Completed"
                control={control}
                options={yesNoDropdown}
                defaultId={defaultValue?.program3Completed}
                register={register('program3Completed', {
                  onBlur: (e) =>
                    dispatch(setProgram3Completed(e.target.value)),
                })}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={2.4}>
            <Typography style={{ color: '#b9b2b2' }}>
              How Long In Treatment?
            </Typography>
            <Box>
              <FormTextField
                name="program1TreatmentLength"
                control={control}
                type="text"
                register={register('program1TreatmentLength', {
                  onBlur: (e) =>
                    dispatch(setProgram1TreatmentLength(e.target.value)),
                })}
              />
              <FormTextField
                name="program2TreatmentLength"
                control={control}
                type="text"
                register={register('program2TreatmentLength', {
                  onBlur: (e) =>
                    dispatch(setProgram2TreatmentLength(e.target.value)),
                })}
              />
              <FormTextField
                name="program3TreatmentLength"
                control={control}
                type="text"
                register={register('program3TreatmentLength', {
                  onBlur: (e) =>
                    dispatch(setProgram3TreatmentLength(e.target.value)),
                })}
              />
            </Box>
          </Grid>
        </Grid>
        <Box style={{ display: 'flex', width: '-webkit-fill-available' }}>
          <FormTextField
            name="treatmentAccomplishments"
            control={control}
            type="text"
            multiline={true}
            rows={3}
            label="Treatment Accomplishment (Significant observation, program participation, attitude towards recovery, work and performence, strengths/weaknesses)"
            register={register('treatmentAccomplishments', {
              onBlur: (e) =>
                dispatch(setTreatmentAccomplishments(e.target.value)),
            })}
            errors={!!errors.treatmentAccomplishments}
            helperText={errors?.treatmentAccomplishments?.message}
          />
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'start',
            width: '-webkit-fill-available',
          }}
        >
          <Typography variant="h5">Continuing Care Recommendation</Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6">Referral Type</Typography>
            <FormInputMultiCheckbox
              control={control}
              name="referredForTreatment"
              label="Referred for Treatment"
              checked={defaultValue?.referredForTreatment}
              register={register('referredForTreatment', {
                onBlur: (e) =>
                  dispatch(setReferredForTreatment(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              control={control}
              name="notReferredInappropriate"
              label="Not Referred-Inappropriate"
              checked={defaultValue?.notReferredInappropriate}
              register={register('notReferredInappropriate', {
                onBlur: (e) =>
                  dispatch(setNotReferredInappropriate(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              control={control}
              name="notReferredRefusingTreatment"
              label="Not Referred-Refusing Treatment"
              checked={defaultValue?.notReferredRefusingTreatment}
              register={register('notReferredRefusingTreatment', {
                onBlur: (e) =>
                  dispatch(setNotReferredRefusingTreatment(e.target.value)),
              })}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6">Program Modality</Typography>
            <FormInputMultiCheckbox
              control={control}
              name="residential"
              label="Residential"
              checked={defaultValue?.residential}
              register={register('residential', {
                onBlur: (e) => dispatch(setResidential(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              control={control}
              name="soberLiving"
              label="Sober Living"
              checked={defaultValue?.soberLiving}
              register={register('soberLiving', {
                onBlur: (e) => dispatch(setSoberLiving(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              control={control}
              name="outPatient"
              label="OutPatient"
              checked={defaultValue?.outPatient}
              register={register('outPatient', {
                onBlur: (e) => dispatch(setOutPatient(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              control={control}
              name="dayTreatment"
              label="Day Treatment"
              checked={defaultValue?.dayTreatment}
              register={register('dayTreatment', {
                onBlur: (e) => dispatch(setDayTreatment(e.target.value)),
              })}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6">Program Options</Typography>
            <FormInputMultiCheckbox
              control={control}
              name="recommendResidentialWithChild"
              label="Residential w/Children"
              checked={defaultValue?.recommendResidentialWithChild}
              register={register('recommendResidentialWithChild', {
                onBlur: (e) =>
                  dispatch(setRecommendResidentialWithChild(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              control={control}
              name="recommendSoberLivingWithChild"
              label="Sober Living w/Children"
              checked={defaultValue?.recommendSoberLivingWithChild}
              register={register('recommendSoberLivingWithChild', {
                onBlur: (e) =>
                  dispatch(setRecommendSoberLivingWithChild(e.target.value)),
              })}
            />
            <FormInputMultiCheckbox
              control={control}
              name="recommendSoberLivingWithIntensiveOdf"
              label="w/Intensive Outpatient"
              checked={defaultValue?.recommendSoberLivingWithIntensiveOdf}
              register={register('recommendSoberLivingWithIntensiveOdf', {
                onBlur: (e) =>
                  dispatch(
                    setRecommendSoberLivingWithIntensiveOdf(e.target.value)
                  ),
              })}
            />
            <FormInputMultiCheckbox
              control={control}
              name="FOTEP"
              label="FOTEP"
              checked={defaultValue?.FOTEP}
              register={register('FOTEP', {
                onBlur: (e) => dispatch(setFOTEP(e.target.value)),
              })}
            />
          </Grid>
        </Grid>
        <Box style={{ display: 'flex', width: '-webkit-fill-available' }}>
          <FormTextField
            name="commentOnRecommendations"
            control={control}
            type="text"
            multiline={true}
            rows={2}
            label="Please Comments On Recommendations"
            register={register('commentOnRecommendations', {
              onBlur: (e) =>
                dispatch(setCommentOnRecommendations(e.target.value)),
            })}
            errors={!!errors.commentOnRecommendations}
            helperText={errors?.commentOnRecommendations?.message}
          />
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'start',
            width: '-webkit-fill-available',
          }}
        >
          <Typography variant="h5">Program Transitional Staff</Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <InputDropdown
              name="programTransitionalStaffId"
              control={control}
              options={profA2ReferenceInfo?.programTransitionalStaff}
              defaultId={defaultValue?.programTransitionalStaffId}
              valueAsKey={true}
              register={register('programTransitionalStaffId', {
                onBlur: (e) =>
                  dispatch(setProgramTransitionalStaffId(e.target.value)),
              })}
            />
            <FormTextField
              name="printedName"
              control={control}
              type="text"
              label="Printed Name"
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormTextField
              name="signature"
              control={control}
              type="text"
              label="Signature"
              disabled={true}
            />
            <FormTextField
              name="telephoneNumber"
              control={control}
              type="text"
              label="Telephone Number"
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormTextField
              name="faxNumber"
              control={control}
              type="text"
              label="Fax Number"
              disabled={true}
            />
            <FormTextField
              name="dateSigned"
              control={control}
              type="date"
              label="Date Signed"
              shrink={true}
              register={register('dateSigned', {
                onBlur: (e) => dispatch(setDateSigned(e.target.value)),
              })}
            />
          </Grid>
        </Grid>
        {getSaveCancel(handleCancelPopUp, null, handleSubmit(onSubmit, onError))}
      </Grid>
      <FormSuccess formSuccess={formSuccess} setFormSuccess={setFormSuccess} />
      <CancelPopUp cancelPopUp={cancelPopUp} setCancelPopUp={setCancelPopUp} />
      <ProfA1PdfForm open={openProfilePDF} setOpen={setOpenProfilePDF} />
    </>
  );
};

export default ProfA2;
